/* Naht & Leinen – Startseite „Leinen-Kino“: Farbwahl im Beaubag-Set ([data-nl-set]).
   Die gewählte Farbe erscheint im Text und im Knopf und stellt die Links der Set-Karten auf die passende Variante:
   Optionen mit „Design“ im Namen = Farbe, alle übrigen = Wert der ersten Variante (z. B. Verschluss „Leder“). */
(function () {
  'use strict';
  if (window.NlSet) return;

  function lies(el, name) {
    try {
      return JSON.parse(el.getAttribute(name) || '[]');
    } catch (e) {
      return [];
    }
  }

  function variante(karte, farbe) {
    var v = karte.varianten;
    if (!v.length) return null;
    var erste = v[0].o;
    for (var n = 0; n < v.length; n++) {
      var passt = true;
      for (var j = 0; j < karte.optionen.length; j++) {
        var soll = /Design/.test(karte.optionen[j]) ? farbe : erste[j];
        if (v[n].o[j] !== soll) {
          passt = false;
          break;
        }
      }
      if (passt) return v[n];
    }
    return null;
  }

  function init(root) {
    if (root.__nlSet) return;
    root.__nlSet = true;
    var name = root.querySelector('[data-nl-set-farbname]');
    var beliebt = root.querySelector('[data-nl-set-beliebt]');
    var knopf = root.querySelector('[data-nl-set-knopf]');
    var karten = Array.prototype.map.call(root.querySelectorAll('[data-nl-set-karte]'), function (el) {
      return {
        url: el.getAttribute('data-url'),
        optionen: lies(el, 'data-optionen'),
        varianten: lies(el, 'data-varianten'),
        link: el.querySelector('[data-nl-set-link]')
      };
    });

    function setze(farbe) {
      if (name) name.textContent = farbe;
      if (beliebt) beliebt.hidden = farbe !== root.getAttribute('data-beliebt');
      if (knopf) knopf.textContent = (knopf.getAttribute('data-vorlage') || knopf.textContent).replace('[farbe]', farbe);
      karten.forEach(function (k) {
        if (!k.link || !k.url) return;
        var v = variante(k, farbe);
        k.link.setAttribute('href', v ? k.url + '?variant=' + v.id : k.url);
      });
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-nl-set-wahl]'), function (r) {
      r.addEventListener('change', function () {
        if (r.checked) setze(r.value);
      });
    });

    // Nach „Zurück“ im Browser bleibt die Auswahl erhalten: Links und Texte dazu passend setzen
    var gewaehlt = root.querySelector('[data-nl-set-wahl]:checked');
    if (gewaehlt) setze(gewaehlt.value);
  }

  function start(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-nl-set]'), init);
  }

  window.NlSet = { start: start };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document); });
  else start(document);
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
